// extracted by mini-css-extract-plugin
export var warningWrapper = "s_sp d_w d_bF d_bP d_bJ d_n d_0 d_bS";
export var btn = "s_mB d_cD d_b1 d_dB d_dr";